import { ALWAYS_VISIBLE_INFRASTRUCTURE_TYPES } from '../../../constants/infrastructure';

export const getZoom = (length: number) => (length === ALWAYS_VISIBLE_INFRASTRUCTURE_TYPES.length ? 16 : 15);
